import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22font.config.ts%22,%22import%22:%22Cairo%22,%22arguments%22:[{%22subsets%22:[%22arabic%22,%22latin%22],%22preload%22:false,%22variable%22:%22--font-cairo%22}],%22variableName%22:%22fontCairo%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Cairo', 'Cairo Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
